function changeAlphabet(that) {
  $(that).siblings().removeClass("selected");
  $(that).addClass("selected");
  let link_holder = $("#" + $(that).data("target"));
  link_holder.siblings().removeClass("active");
  link_holder.addClass("active");
}

function getProductFullPrice() {
  const element = document.querySelector('sale-price');
  const textContent = element.textContent;
  const priceMatch = textContent.match(/\$(\d{1,3}(?:,\d{3})*(\.\d+)?)/);
  if (priceMatch) {
    return parseFloat(priceMatch[1].replace(/,/g, ''));
  } else {
    return null;
  }
}

document.addEventListener('DOMContentLoaded', function() {
  if ($("#alphabet-menu").length) {
    $("#alphabet-menu").on("click", ".letterTxt", function (e) {
      e.preventDefault();
      e.stopPropagation();
      changeAlphabet(this);
    });

    $(".alphabet-menu .letterTxt")
      .mouseenter(function () {
        let that = this;
        timer = setTimeout(function () {
          changeAlphabet(that);
        }, 150 /* <--- the delay */);
      })
      .mouseleave(function () {
        clearTimeout(timer);
      });
  }
  $('body').addClass('loaded');
});

document.addEventListener('DOMContentLoaded', function() {
  if ($("#AlphabetMenu").length) {
    $("#AlphabetMenu").on("click", ".letterTxt", function (e) {
      e.preventDefault();
      e.stopPropagation();
      changeAlphabet(this);
    });

    $(".AlphabetMenu .letterTxt")
      .mouseenter(function () {
        let that = this;
        timer = setTimeout(function () {
          changeAlphabet(that);
        }, 150 /* <--- the delay */);
      })
      .mouseleave(function () {
        clearTimeout(timer);
      });
  }

  if ($(".accordion-page").length) {
    $(".accordion-page").on("click", ".accordion-faq-wrapper", function (e) {
      $(this).toggleClass("ele-triggered");
      $(this).siblings().removeClass("ele-triggered");
    });
  }
  // Disabled when Route notified us of a fix
  // detectAndFixDrawerCartTotal();

  
  
});
                                                          
/* Sale Badge Learn More Code */
document.addEventListener('DOMContentLoaded', function() {
  if ($(".sale_badge_container").length) {
    $(".sale_badge_container").on("click", ".sale_badge_learn,.adv_sale_badge_learn,adv_sale_badge_learn_2", function (e) {
      e.preventDefault();
      e.stopPropagation();
      $('.sale_badge_learn_more').toggleClass('active');
    });

    $(".sale_badge_container")
      .mouseenter(function () {
        let that = this;
        timer = setTimeout(function () {
          $(that).find('.sale_badge_learn_more').addClass('active');
        }, 150 /* <--- the delay */);
      })
      .mouseleave(function () {
        clearTimeout(timer);
        let that = this;
          $(that).find('.sale_badge_learn_more').removeClass('active');
        
      });
  }
  
})

/* GWP Learn More Code */
document.addEventListener('DOMContentLoaded', function() {
  if ($("#floatOverGwpBadgeMore").length) {
    $("#floatOverGwpBadgeMore").on("click", ".gwp_badge_learn_more,.adv_gwp_badge_learn_more,adv_gwp_badge_learn_more_2", function (e) {
      e.preventDefault();
      e.stopPropagation();
      $('#floatOverGwpBadgeMore').toggleClass('active');
    });

    $("#floatOverAdvBadge ")
      .mouseenter(function () {
        let that = this;
        timer = setTimeout(function () {
          $('#floatOverGwpBadgeMore').addClass('active');
        }, 150 /* <--- the delay */);
      })
      .mouseleave(function () {
        clearTimeout(timer);
        
          $('#floatOverGwpBadgeMore').removeClass('active');
        
      });
  }
  
})


/*
//this code sets the top position of the mobile nav based on the existence of the announcement bars
document.addEventListener('DOMContentLoaded', () => {
  let headerHeight = 0, announcementBarHeight = 0;
  const header = document.querySelector('header.shopify-section--header');
  if(header) headerHeight = header.offsetHeight;
  const announcementBar = document.querySelector('aside.shopify-section--announcement-bar');
  if(announcementBar) announcementBarHeight = announcementBar.offsetHeight;
  const topPosition = headerHeight + announcementBarHeight;
  const headerSidebar = document.querySelector('header-sidebar');
  headerSidebar.shadowRoot.querySelector('div[part="base"]').setAttribute('style','top:'+topPosition+'px !important;height:calc(100% - '+topPosition+'px) !important;');
  headerSidebar.shadowRoot.querySelector('div[part="overlay"]').setAttribute('style','top:'+topPosition+'px !important;min-height:calc(100vh - '+topPosition+'px) !important;');
  document.querySelector('button[aria-controls="sidebar-menu"]').addEventListener('click',function(){
    this.setAttribute('style','display:none;');
    document.querySelector('a.navsearchicon').setAttribute('style','display:none;');
    document.querySelector('button[aria-controls="sidebar-menu-close"]').setAttribute('style','display:block;');
  });
  document.querySelector('button[aria-controls="sidebar-menu-close"]').addEventListener('click',function(){
    document.querySelector('button[aria-controls="sidebar-menu"]').click();
    this.setAttribute('style','display:none;');
    document.querySelector('a.navsearchicon').setAttribute('style','display:block;');
    document.querySelector('button[aria-controls="sidebar-menu"]').setAttribute('style','display:block;');
  });
});
*/
// Brilliant Cartwatcher Script https://mikefallows.com/posts/observing-cart-changes-in-a-shopify-theme/
class CartWatcher {

  init() {
    this.emitCartChanges().then(() => {
      this.observeCartChanges();
    });
  }

  async fetchCart() {
    const response = await fetch('/cart.js');
    return response.json();
  }

  storeCart(cart) {
    localStorage.setItem('cart', JSON.stringify(cart));
  }

 storedCart() {
    return JSON.parse(localStorage.getItem('cart')) || { items: [] };
  }

 findCartChanges(oldCart, newCart) {
    const onlyInLeft = (l, r) => l.filter(li => !r.some(ri => li.key == ri.key));
    let result = {
      added: onlyInLeft(newCart.items, oldCart.items),
      removed: onlyInLeft(oldCart.items, newCart.items),
    };

    oldCart.items.forEach(oi => {
      const ni = newCart.items.find(i => i.key == oi.key && i.quantity != oi.quantity);
      if (!ni) return;
      let quantity = ni.quantity - oi.quantity;
      let item = { ...ni };
      item.quantity = Math.abs(quantity);
      quantity > 0
        ? result.added.push(item)
        : result.removed.push(item)
    });

    return result;
  }

  async emitCartChanges() {
    const newCart = await this.fetchCart();
    const oldCart = this.storedCart();
    const changes = this.findCartChanges(oldCart, newCart);

    const event = new CustomEvent("cart_changed", { detail: changes });
    window.dispatchEvent(event);

    this.storeCart(newCart);
  }

 observeCartChanges() {
    const cartObserver = new PerformanceObserver((list) => {
      list.getEntries().forEach((entry) => {
        const isValidRequestType = ['xmlhttprequest', 'fetch'].includes(entry.initiatorType);
        const isCartChangeRequest = /\/cart\//.test(entry.name);
        if (isValidRequestType && isCartChangeRequest) {
          this.emitCartChanges();
        }
      });
    });
    cartObserver.observe({ entryTypes: ["resource"] });
  }
}